import { titleCase } from 'utils/helperFunctions';
import { formatAddedOn, formatHostSmsNumber, providerLabel } from './hostSmsConstants';
import { A2pLinkStatus, A2pLinkableNumber } from '@/apis/business/setting/phoneNumbers/types';

export const formatA2pNumber = formatHostSmsNumber;
export const formatA2pAddedOn = (value?: string | null) => {
  if (!value) return '—';
  if (/^\d{4}-\d{2}-\d{2} /.test(value)) return value;
  const formatted = formatAddedOn(value);
  return formatted === '-' ? '—' : formatted;
};

export const formatA2pProvider = (provider?: string | null) => {
  const known = providerLabel(provider);
  if (known && known !== provider) return known;
  return titleCase((provider || 'unknown').replace(/_/g, ' '));
};

export const LINK_STATUS_CHIP: Record<A2pLinkStatus, { label: string; color: string; bg: string }> = {
  linking: { label: 'In Progress', color: '#B45309', bg: '#FEF3C7' },
  unlinking: { label: 'In Progress', color: '#B45309', bg: '#FEF3C7' },
  linked: { label: 'Linked', color: '#15803D', bg: '#DCFCE7' },
  failed: { label: 'Failed', color: '#B91C1C', bg: '#FEE2E2' }
};

export const isLinkPending = (row: A2pLinkableNumber) =>
  row.link_status === 'linking' || row.link_status === 'unlinking';

export const isOnCampaign = (row: A2pLinkableNumber) => row.link_status === 'linked' || row.link_status === 'linking';
